export const CHAIN_ID = process.env.REACT_APP_CHAIN_ID || '97';
